import { axiosInstances } from 'utilities/axios/Instances/axios.instances';

const getClientProjects = clientId => {
  return axiosInstances.withAuthToken().get(`/clients/${clientId}/projects`);
};
export const projectsService = { getClientProjects };
